import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { trackSkoolClick } from "@/lib/tracking";

const SKOOL_URL = "https://www.skool.com/sircs-reprogramacion-mental-8281";

const NAV = [
  { id: "problema", label: "Diagnóstico" },
  { id: "solucion", label: "Sistema" },
  { id: "creador", label: "Santi" },
  { id: "precio", label: "Acceso" },
  { id: "faq", label: "FAQ" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-[#0B0E13]/85 border-b border-[#1E252F]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        <a href="#top" data-testid="navbar-logo" className="flex items-center gap-2 group">
          <img
            src="https://customer-assets.emergentagent.com/job_sircs-community/artifacts/saiuvqxc_Photoroom_20260621_143416.png"
            alt="SIRCS — Santi Lorenzo"
            className="h-12 sm:h-14 w-auto"
            style={{ mixBlendMode: "screen" }}
          />
        </a>

        <div className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.id}
              href={`#${n.id}`}
              data-testid={`nav-link-${n.id}`}
              className="font-body text-[12px] uppercase tracking-[0.22em] text-pearl/70 hover:text-cream transition-colors"
            >
              {n.label}
            </a>
          ))}
        </div>

        <a
          href={SKOOL_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackSkoolClick("navbar")}
          data-testid="navbar-cta-button"
          className="hidden md:inline-flex items-center gap-2 btn-pearl px-5 py-2.5 rounded-full font-body text-[12px] uppercase tracking-[0.18em]"
        >
          Entrar <ArrowUpRight size={14} />
        </a>

        <button
          onClick={() => setOpen(!open)}
          data-testid="navbar-mobile-toggle"
          className="md:hidden text-cream"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-[#0B0E13] border-t border-[#1E252F]"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {NAV.map((n) => (
                <a
                  key={n.id}
                  href={`#${n.id}`}
                  onClick={() => setOpen(false)}
                  className="font-body text-sm uppercase tracking-[0.22em] text-pearl/80 hover:text-cream"
                  data-testid={`mobile-nav-link-${n.id}`}
                >
                  {n.label}
                </a>
              ))}
              <a
                href={SKOOL_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="mobile-navbar-cta-button"
                className="mt-2 btn-pearl px-5 py-3 rounded-full font-body text-[12px] uppercase tracking-[0.18em] w-fit inline-flex items-center gap-2"
              >
                Entrar al sistema <ArrowUpRight size={14} />
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}
